import Vue from 'vue'
import App from './learning_categories/app.vue'
import TurbolinksAdapter from 'vue-turbolinks';

Vue.use(TurbolinksAdapter)

document.addEventListener('turbo:load', () => {
  const templateBuilder = document.getElementById('learning-category-builder');

  if (templateBuilder) {
    new Vue({
      el: '#learning-category-builder',
      render: h => h(App)
    }).$mount();
  }
});
